import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=0544ae0e&scoped=true"
import script from "./order-card.vue?vue&type=script&lang=js"
export * from "./order-card.vue?vue&type=script&lang=js"
import style0 from "./order-card.vue?vue&type=style&index=0&id=0544ae0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0544ae0e",
  null
  
)

export default component.exports